import React, { ReactNode } from 'react';
import Stack from '../Stack/Stack';

type Props = {
  children: ReactNode;
};

const Table = ({ children }: Props) => {
  return (
    <Stack bg="gray-100" space={1}>
      {children}
    </Stack>
  );
};

Table.displayName = 'Table';
export default Table;
